import { createAction } from 'kea';

export const logout = createAction('LOGOUT', () => true);
export const notAuthorized = createAction('NOT_AUTHORIZED', () => true);
export const serviceUnavailable = createAction('SERVICE_UNAVAILABLE', () => true);
